import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
    userId: string | undefined;
    userCapabilities: string[];
    userLoaded: boolean;
    hasAccess: boolean;
}

export const initialState: UserState = {
    userId: undefined,
    userCapabilities: [],
    userLoaded: false,
    hasAccess: false,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserId: (state, action: PayloadAction<string | undefined>) => {
            state.userId = action.payload;
        },
        setUserCapabilities: (state, action: PayloadAction<string[]>) => {
            state.userCapabilities = action.payload;
        },
        setUserLoaded: (state, action: PayloadAction<boolean>) => {
            state.userLoaded = action.payload;
        },
        setUserHasAccess: (state, action: PayloadAction<boolean>) => {
            state.hasAccess = action.payload;
        },
    },
});

export const { 
    setUserId,
    setUserCapabilities,
    setUserLoaded,
    setUserHasAccess,
 } = userSlice.actions;

export default userSlice.reducer;
